import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { show as openDrawerLeft } from '../redux/slices/Drawer/drawerLeft'
import { setEnableButton } from '../redux/slices/Modal/enableButton'
import * as RT from '../config/routeType'

const normalizeRouteValue = value => {
  if (value == null) return ''
  const text = String(value).trim()
  try {
    return decodeURIComponent(text)
  } catch {
    return text
  }
}

export const useTreeNavigation = ({
  map,
  treeId,
  treeData,
  alertRef,
  selectTree, // ✅ Usar función centralizada
  popupLngLat: thereIsUnclusteredPointClick,
  isEditMode = false,
}) => {
  let location = useLocation()
  const dispatch = useDispatch()
  const lastTreeIdRef = useRef(null)
  const lastNotFoundRef = useRef(null)

  useEffect(() => {
    if (!treeId || !treeData?.features?.length) {
      lastTreeIdRef.current = null
      return undefined
    }

    const normalizedTreeId = normalizeRouteValue(treeId)
    const routeKey = `${location.pathname}:${normalizedTreeId}`

    // ✅ Evitar procesamiento duplicado del mismo árbol ya encontrado
    if (lastTreeIdRef.current === routeKey) return

    const isManagementRoute = location.pathname.includes(RT.MANAGEMENT_TREE)
    if (thereIsUnclusteredPointClick && !isManagementRoute) {
      return undefined
    }

    const key = isManagementRoute ? 'id' : 'code'
    const matchedTree = treeData.features.find(
      feature => normalizeRouteValue(feature.properties?.[key]) === normalizedTreeId
    )

    if (!matchedTree) {
      dispatch(openDrawerLeft(false))
      if (!isEditMode && lastNotFoundRef.current !== routeKey) {
        lastNotFoundRef.current = routeKey
        alertRef?.current?.message('El código del árbol no existe.')
        alertRef?.current?.openAlert(true)
      }
      return undefined
    }

    const coordinates = matchedTree.geometry.coordinates
    const selected = selectTree
      ? selectTree(matchedTree, coordinates, 'navigation') !== false
      : false

    if (!selected) return undefined

    lastTreeIdRef.current = routeKey
    lastNotFoundRef.current = null
    dispatch(setEnableButton(false))
    dispatch(openDrawerLeft(false))
    return undefined
  }, [
    treeId,
    treeData,
    location.pathname,
    alertRef,
    dispatch,
    selectTree,
    thereIsUnclusteredPointClick,
    isEditMode,
  ])
}
